import * as React from 'react';

import loginRoutes from './components/login/Login.Routes';
import mainRoutes from './components/main/Main.Routes';
import adminRoutes from './components/admin/Admin.Routes';
import clientRoutes from './components/clients/Client.Routes';
import companyRoutes from './components/companies/Company.Routes';
import contactRoutes from './components/contacts/Contact.Routes';
import profileRoutes from './components/profile/Profile.Routes';
import timeRoutes from './components/time/TimeExpense.Routes';
import projectRoutes from './components/project/Project.Routes';
import landmenRoutes from './components/personnel/Personnel.Routes';
import apRoutes from './components/accounts-payable/AP.Routes';
import arRoutes from './components/accounts-receivable/AR.Routes';
import gisRoutes from './components/gis/GIS.Routes';
import cpRoutes from './components/client-project/CP.Routes';
import pbRoutes from './components/project-billing/PB.Routes';
import invoicingRoutes from './components/invoicing/Invoicing.Routes';
import reportsRoutes from './components/reports/Reports.Routes';

import Forbidden from 'src/components/common/AccessDeniedPage';
import NotFound from './components/common/NotFoundPage';
import SecondWindow from './components/common/SecondWindow';
import FormDoc from 'src/components/FormPoc/Document';
import FormPoc from 'src/components/FormPoc/Form';

import { Route } from 'react-router-dom';
import LeaseDocument from './components/project/sections/LeasingComponents/LeaseDocument';
import leasesRoutes from './components/leases/Leases.Routes';
import UserDetails from './models/UserDetails';

export default function getRouter(isLoggedIn: boolean, isAdmin: boolean, user: UserDetails) {
    const allRoutes = [
        ...mainRoutes(isLoggedIn),
        ...adminRoutes(isLoggedIn, user),
        ...loginRoutes(isLoggedIn),
        ...projectRoutes(isLoggedIn),
        ...clientRoutes(isLoggedIn),
        ...companyRoutes(isLoggedIn),
        ...contactRoutes(isLoggedIn),
        ...profileRoutes(isLoggedIn),
        ...timeRoutes(isLoggedIn),
        ...landmenRoutes(isLoggedIn),
        ...apRoutes(isLoggedIn),
        ...arRoutes(isLoggedIn),
        ...pbRoutes(isLoggedIn),
        ...cpRoutes(isLoggedIn),
        ...reportsRoutes(isLoggedIn),
        ...gisRoutes(isLoggedIn),
        ...leasesRoutes(isLoggedIn, user),
        // ...invoicingRoutes(isLoggedIn),
        ...invoicingRoutes(isLoggedIn),
        <Route key="second-window" path="/second-window" component={SecondWindow} />,
        <Route key="formpoc" path="/formpoc" component={FormPoc} />,
        <Route key="formdoc" path="/formdoc" component={FormDoc} />,
        <Route key="leasedoc" path="/lease-form" component={LeaseDocument} />,
        <Route key="forbidden" component={Forbidden} />,
        <Route key="not-found" component={NotFound} />,
    ];

    return allRoutes;
}



// WEBPACK FOOTER //
// ./src/routes.tsx